import { useCallback, useMemo, useState } from 'react';
import mediaSeed from '../data/mediaSeed';

const STORAGE_KEY = 'ai-media-on-posts-v1';

function loadSavedMedia() {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(saved) ? saved : [];
  } catch (error) {
    return [];
  }
}

const useMediaLibrary = () => {
  const [savedMedia, setSavedMedia] = useState(loadSavedMedia);

  const media = useMemo(() => [...savedMedia, ...mediaSeed], [savedMedia]);

  const addMedia = useCallback((newMedia) => {
    setSavedMedia((current) => {
      const next = [newMedia, ...current];
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch (error) {
        // 저장 공간이 부족해도 현재 화면에서는 등록 결과를 유지합니다.
      }
      return next;
    });
  }, []);

  return { addMedia, media };
};

export default useMediaLibrary;
